/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { useMenu } from "react-instantsearch-hooks-web";
import { useBoatQuery } from "../utils/useBoatQuery";

const getValue = (attribute) => {
  const query = new URLSearchParams(window.location.search);
  return query.get(`products[menu][${attribute}]`) ?? " ";
};

export const SelectMenu = (props) => {
  const { filterByAttribute } = useBoatQuery(props.attribute);
  const { items, refine } = useMenu(props);

  const filteredItems = useMemo(
    () => filterByAttribute(props.attribute?.toLowerCase(), items),
    [props.attribute, items, filterByAttribute]
  );

  const handleChange = (value) => {
    refine(value);
  };

  return (
    <select
      defaultValue={getValue(props.attribute)}
      className="w-full py-1.5"
      onChange={(e) => handleChange(e.target.value)}
    >
      <option value="">Show All</option>
      {filteredItems.map((item) => (
        <option key={item.value} value={item.value}>
          {item.label} ({item.count})
        </option>
      ))}
    </select>
  );
};
